import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./CheckoutPage.css";
import { writeNewData } from "../DemoData/writeData";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CheckoutPage = () => {
  const localMachineHitLimit = 15;
  const sessionKey = "OC";
  const location = useLocation();
  const { productId, productName, quantity } = location.state || {};
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
    pinCode: "",
    email: "",
    saveInfo: true,
  });

  const [orderPlaced, setOrderPlaced] = useState(false);
  const [orderError, setOrderError] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const currentCount = parseInt(sessionStorage.getItem(sessionKey)) || 0;

  useEffect(() => {
    if (currentCount >= localMachineHitLimit) {
      setIsBlocked(true);
    } else {
      sessionStorage.setItem(sessionKey, currentCount + 1);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    const dbObj = {
      email: formData.email,
      userInfo: {
        name: formData.name,
        mobile: formData.mobile,
        address: formData.address,
        pinCode: formData.pinCode,
        saveInfo: formData.saveInfo,
      },
      orderInfo: {
        productId: productId,
        productName: productName,
        quantity: quantity,
        timestamp: new Date(),
        orderStatus: "Active",
      },
    };
    e.preventDefault();

    if (!isBlocked) {
      // Validation for Pin Code and Email
      if (!/^\d{6}$/.test(formData.pinCode)) {
        alert("Please enter a valid 6-digit Pin Code.");
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        alert("Please enter a valid Email address.");
        return;
      }

      const result = await writeNewData(dbObj);

      if (result) {
        setOrderPlaced(true);
        setOrderError(false);
        sessionStorage.setItem(sessionKey, currentCount + 1);
      } else {
        setOrderError(true);
      }
    }
  };

  if (orderPlaced) {
    return (
      <div className="checkout-container">
        <div className="party-popper">🎉</div>
        <h1 className="success-message">Yeah! Your order is placed!</h1>
        <button className="back-to-home-button" onClick={() => navigate("/")}>
          Back to Home Page
        </button>
      </div>
    );
  }
  if (orderError) {
    return (
      <div className="checkout-container">
        <h3 className="error-message">
          Something went wrong. Please try again later.
        </h3>
        <button className="back-to-home-button" onClick={() => navigate("/")}>
          Back to Home Page
        </button>
      </div>
    );
  }

  return (
    <div className="checkout-wrapper">
      {!isBlocked ? (
        <>
          <div className="checkout-container">
            {/* Back Button */}
            <button
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "#f0f0f0",
                color: "black",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                border: "none",
              }}
              onClick={() => navigate("/")}
            >
              <ArrowBackIcon />
            </button>

            <h1 className="checkout-title">Checkout</h1>
            <form className="checkout-form" onSubmit={handleSubmit}>
              <label className="form-label">
                Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </label>
              <label className="form-label">
                Mobile:
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </label>
              <label className="form-label">
                Address:
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  className="form-textarea"
                />
              </label>
              <label className="form-label">
                Pin Code:
                <input
                  type="text"
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </label>
              <label className="form-label">
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </label>
              <label className="form-checkbox">
                <input
                  type="checkbox"
                  name="saveInfo"
                  checked={formData.saveInfo}
                  onChange={handleChange}
                />
                Save information for future delivery
              </label>
              <button type="submit" className="submit-button">
                Place Order
              </button>
            </form>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              textAlign: "center",
              marginTop: "50px",
              color: "#747474",
              fontSize: "18px",
            }}
          >
            You've reached the maximum number of buy attempts. Please contact us
            for further assistance.
          </div>
        </>
      )}
    </div>
  );
};

export default CheckoutPage;
